export { default } from './ProductSpotlight'
